"use client";

import { useEffect } from "react";

/**
 * ルートレベルのエラーバウンダリ。requireAuth()の失敗（例: Prance ID側App Client未発行、
 * docs/design.md §15）等、ページレンダリング中の例外を汎用メッセージで表示する。
 * 詳細なエラー内容は表示しない — ユーザー側で対処できないサーバー起因のエラーのため。
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 text-center">
      <h1 className="mb-2 text-heading">エラーが発生しました</h1>
      <p className="text-muted">
        しばらく経ってから再度お試しください。問題が解決しない場合は管理者にお問い合わせください。
      </p>
    </main>
  );
}
